/**
 * Batch H1 — Creator view of who claimed a link, their entitlement and NFT issuance state.
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import theme from '../theme';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ClaimantsList({ claimId, auth }) {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    axios.get(`${API}/creator/claim-links/${claimId}/claimants`, auth)
      .then(res => setRows(res.data?.claimants || []))
      .catch(e => setErr(e?.response?.data?.detail || 'Failed to load claimants'));
  }, [claimId, auth]);

  const box = { marginTop: 10, padding: 12, background: theme.colors.bg.card, borderRadius: theme.radius.sm, border: `1px solid ${theme.colors.borders}`, fontSize: 12 };
  if (err) return <div data-testid={`claimants-error-${claimId}`} style={{ ...box, color: theme.colors.status.error }}>{err}</div>;
  if (!rows) return <div data-testid={`claimants-loading-${claimId}`} style={box}>Loading claimants…</div>;
  if (rows.length === 0) return <div data-testid={`claimants-empty-${claimId}`} style={{ ...box, color: theme.colors.text.muted }}>No one has claimed this link yet.</div>;
  return (
    <div data-testid={`claimants-list-${claimId}`} style={box}>
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1.4fr 1fr 1.2fr', gap: 8, fontWeight: 700, color: theme.colors.text.muted, marginBottom: 6 }}>
        <div>Holder</div><div>Claimed</div><div>Entitlement</div><div>NFT issuance</div>
      </div>
      {rows.map(r => (
        <div key={r.redemption_id} data-testid={`claimant-row-${r.redemption_id}`}
          style={{ display: 'grid', gridTemplateColumns: '2fr 1.4fr 1fr 1.2fr', gap: 8, padding: '6px 0', borderTop: `1px solid ${theme.colors.borders}` }}>
          <div style={{ wordBreak: 'break-all' }}>{r.holder_email || 'Guest holder'}</div>
          <div>{r.claimed_at ? new Date(r.claimed_at).toLocaleString() : '—'}</div>
          <div style={{ textTransform: 'capitalize' }}>{r.entitlement_status}</div>
          <div data-testid={`claimant-issuance-${r.redemption_id}`} title={r.issuance?.reason || ''}
            style={{ color: r.issuance?.status === 'issued' ? theme.colors.status.success : '#92400E', fontWeight: 700 }}>
            {r.issuance?.label}
          </div>
        </div>
      ))}
      <div style={{ marginTop: 8, color: theme.colors.text.muted, fontSize: 11 }}>
        NFTs are only shown as issued when an on-chain ownership record exists. The current contract does not mint from claims yet.
      </div>
    </div>
  );
}
